import styled from 'styled-components'

export const SocialMediaButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
`
